module.exports = {
    BASE_URL_ADMIN: 'https://admin.ruhu.sg',
    // BASE_URL_ADMIN: 'http://ruhu.sg:3030',
    // BASE_URL_ADMIN: 'http://test.inspius.com:6969',
    // BASE_URL_ADMIN: 'http://139.59.125.94:8001',
    NUMBER_YEAR_OPERATION: [
        '<1 yrs',
        '1 to 2 yrs',
        '2 to 3 yrs',
        '3 to 4 yrs',
        '4 to 5 yrs',
        '5 to 6 yrs',
        '6 to 7 yrs',
        '7 to 8 yrs',
        '8 to 9 yrs',
        '9 to 10 yrs',
        '10 to 15 yrs',
        '15 to 220 yrs',
        '20 to 25 yrs',
        '25 to 30 yrs',
        '>30 yrs'
    ],
    NUMBER_YEAR_PRACTIVE: [
        '1 to 2 yrs',
        '2 to 3 yrs',
        '3 to 4 yrs',
        '4 to 5 yrs',
        '5 to 6 yrs',
        '6 to 7 yrs',
        '7 to 8 yrs',
        '8 to 9 yrs',
        '9 to 10 yrs',
        '10 to 15 yrs',
        '15 to 220 yrs',
        '20 to 25 yrs',
        '25 to 30 yrs',
        '>30 yrs'
    ],
    PAID_UP_CAPITAL: [
        '<$10000',
        '$10000 to $25000',
        '$25000 to $50000',
        '$50000 to $75000',
        '$75000 to $100000',
        '$10000 to $125000',
        '$125000 to $150000',
        '$150000 to $175000',
        '$175000 to $200000',
        '$200000 to $225000',
        '$225000 to $250000',
        '$250000 to $275000',
        '$275000 to $300000',
        '$300000 to $350000',
        '$350000 to $400000',
        '$400000 to $450000',
        '$450000 to $500000',
        '>$500000'
    ],
    CERTIFICATIONS: [
        'HDB',
        'BCA',
        'CaseTrust',
        'RCMA',
        'RADAC',
        'BizSAFE',
        'ISO',
        'SLOTS',
        'SFA',
        'Others'
    ],
    CERTIFICATIONS_DESIGNER: [
        'HDB',
        'BCA',
        'CONQUAS',
        'Others'
    ],
    CERTIFICATIONS_DESIGNER_FULL: [
        {label: 'HDB', value: 'HDB'},
        {label: 'BCA', value: 'BCA'},
        {label: 'CONQUAS', value: 'CONQUAS'},
        {label: 'Others', value: 'Others'}
    ],
    YEAR_OF_WARRANTY: [
        '0 yrs',
        '1/2 yrs',
        '1 yrs',
        '2 yrs',
        '3 yrs',
        '4 yrs',
        '5 yrs',
        '6 yrs',
        '7 yrs',
        '8 yrs',
        '9 yrs',
        '10 yrs'
    ],
    INSURANCE_PROVIDER: [
        'AXA',
        'Liberty',
        'NTUC',
        'Tokio Marine',
        'MSIG',
        'QBE'
    ],
    EDUCATIONS: [
        'Degree (PhD)',
        'Degree (Master)',
        'Degree (Bachelor)',
        'Diploma',
        'Certificate'
    ],
    EDUCATIONS_PM: [
        'Degree',
        'Diploma',
        'NITEC',
        'O-level',
        'N-level',
        'Sec & Below'
    ],
    NO_3D_DESIGNER: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10
    ]
}
